import React, { useEffect, useRef } from 'react';
import './About.css'; 

const AnimatedSection = ({ title, content, reversed }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
          } else {
            entry.target.classList.remove('fade-in');
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div className={`content-section fade ${reversed ? 'reversed' : ''}`} ref={sectionRef}>
      <div className="text-content full-width">
        <h2>{title}</h2>
        <p>{content}</p>
      </div>
    </div>
  );
};

const About = () => {
  // Hero section reference for animation
  const heroRef = useRef(null);
  
  useEffect(() => {
    // Add fade-in animation to hero on load
    if (heroRef.current) {
      setTimeout(() => {
        heroRef.current.style.opacity = "1";
        heroRef.current.style.transform = "translateY(0)";
      }, 300);
    }
  }, []);

  return (
    <div className="about-container">
      <section 
        className="about-hero" 
        ref={heroRef}
        style={{ opacity: "0", transform: "translateY(-20px)", transition: "all 1s ease" }}
      >
        <div className="hero-content">
          <h1>Our Story</h1>
          <p>Discover the journey of our church and our commitment to building a vibrant community of believers for the God's Kingdom.</p>
        </div>
      </section>

      <section className="about-content">
        <AnimatedSection
          title="Our Mission"
          content="At Faith Tabernacle Church, our mission is to proclaim the word of God. We are committed to the power of faith and spreading the message to those who have yet to hear it. We are a group of born again, baptised and spirit filled believers settled in and around Northamptonshire, UK. Originally from Kerala, India, we serve the Indian Malayali community and have evolved our services to be bilingual (Malayalam-English) to include our children and the local multi-cultural community with the love of Jesus Christ."
          reversed={false}
        />
        
        <AnimatedSection
          title="Our Vision"
          content="Our vision is to create a welcoming and inclusive environment where everyone can experience the love of God. We shine forth the light of Christ's salvation, a steadfast tower for all seeking His divine grace. Our motto, 'Eternity matters', reflects our belief that every individual can and should have a personal relationship with Jesus Christ and be part of a vibrant local church. We emphasise the work of the Holy Spirit and the personal experience of God's presence, believing that through Jesus Christ's death, burial, and resurrection, sins can be forgiven and humanity reconciled with God."
          reversed={false}
        />
        
        <AnimatedSection
          title="Our Values"
          content="Our values are rooted in faith, love, and active discipleship. We are called not just to believe but to become Christ's hands and feet in a world that needs His compassion and grace. Our focus on evangelism helps build the next generation in Jesus Christ. From our early years with just two families, God has blessed us with growth and a new home of worship at 3 Alexandra St, a promised place bestowed upon us by our Heavenly Father."
          reversed={false}
        />
      </section>
      
      <section className="about-cta">
        <div className="cta-content">
          <h2>Join Our Community</h2>
          <p>
            We invite you to become part of our faith family and experience the warmth, fellowship, and spiritual growth at Faith Tabernacle Church.
          </p>
          <button onClick={() => window.location.href='/events'}>Get Involved</button>
        </div>
      </section>
    </div>
  );
};

export default About;
